import * as React from 'react';
import * as Colors from '../../../consts/variables';
import { config } from '../../../config';

export interface IDecisionProps {
    icon: string;
    text: string;
    link: string;
    linkText: string;
    action: string;
    onClick: (link: string, eventAction: string) => void;
}
export class Decision extends React.Component<IDecisionProps, any> {
    styles: any = {
        line: { height: '1px', border: 'solid 1px #f0f0f0', margin: '10px' },
        link: { color: Colors.acqa, fontWeight: 'bold', fontSize: '14px', margin: '20px 0 0 0' },
    };

    render() {
        const { icon, text, link, linkText, onClick, action } = this.props;
        return (
            <div className="startPage--decision-item" onClick={() => onClick(link, action)}>
                <img src={icon} alt={text} />
                <div style={this.styles.line} />
                <span className="startPage--decision-item-text">{text}</span>
                <div style={this.styles.link}>
                    {linkText} <img alt="arrow" src={`${config.images}/common/start/arrow.svg`} />
                </div>
            </div>
        );
    }
}
